import classNames from 'classnames';
import styles from './ReportDismissedSection.module.scss';
import { CYPRESS_DATA } from './constants';
import { EmployeeRowFilter } from './types';

type Props = {
  filter: EmployeeRowFilter;
  search: string;
  allLabel: string;
  errorsLabel: string;
  warningsLabel: string;
  searchPlaceholder: string;
  onFilterChange: (filter: EmployeeRowFilter) => void;
  onSearchChange: (search: string) => void;
};

const TerminatedEmployeesFilters = ({
  filter,
  search,
  allLabel,
  errorsLabel,
  warningsLabel,
  searchPlaceholder,
  onFilterChange,
  onSearchChange,
}: Props) => {
  const options: { value: EmployeeRowFilter; label: string; dataCy: string }[] =
    [
      {
        value: 'all',
        label: allLabel,
        dataCy: CYPRESS_DATA.filterAll,
      },
      {
        value: 'errors',
        label: errorsLabel,
        dataCy: CYPRESS_DATA.filterErrors,
      },
      {
        value: 'warnings',
        label: warningsLabel,
        dataCy: CYPRESS_DATA.filterWarnings,
      },
    ];

  return (
    <div className={styles.filters} data-cy={CYPRESS_DATA.filters}>
      <div
        className={styles.filterGroup}
        role="group"
        aria-label="Filtrera personer"
      >
        {options.map((option) => (
          <button
            key={option.value}
            type="button"
            className={classNames(styles.filterButton, {
              [styles.filterButtonActive]: filter === option.value,
            })}
            aria-pressed={filter === option.value}
            onClick={() => onFilterChange(option.value)}
            data-cy={option.dataCy}
          >
            {option.label}
          </button>
        ))}
      </div>
      <input
        type="search"
        className={styles.search}
        value={search}
        placeholder={searchPlaceholder}
        aria-label={searchPlaceholder}
        onChange={(event) => onSearchChange(event.target.value)}
        data-cy={CYPRESS_DATA.search}
      />
    </div>
  );
};

export default TerminatedEmployeesFilters;
